export default __webpack_public_path__ + "static/media/1.f50f14a0.webp";